export default function handleStripe(transactionDetails) {
  console.log(transactionDetails.url)
  window.location = transactionDetails.url
}
